import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Images/logo.png";
import styles from "./Sidebar.module.css";
import { gsap } from "gsap";
import {
  FaBuilding,
  FaGoogle,
  FaKey,
  FaPhoneAlt,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";
import {
  FaAddressBook,
  FaCampground,
  FaDemocrat,
  FaSackDollar,
  FaTablets,
} from "react-icons/fa6";
import { FiLogOut } from "react-icons/fi";
import { GiHamburgerMenu } from "react-icons/gi";
import { ImExit } from "react-icons/im";
import { AiOutlineSetting } from "react-icons/ai";
import {
  MdAssignment,
  MdCampaign,
  MdDashboardCustomize,
  MdPhone,
  MdSupportAgent,
} from "react-icons/md";
import { BsTelephoneOutbound } from "react-icons/bs";
import { MdManageAccounts } from "react-icons/md";
import { IoTicket } from "react-icons/io5";
import { RiCloseLargeFill, RiRobot2Line, RiRobot3Fill } from "react-icons/ri";
import { FaUserCircle, FaUser, FaEdit, FaTicketAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/authSlice";
import { FaMeta } from "react-icons/fa6";
import { FaLink } from "react-icons/fa6";
import { FaChartLine } from "react-icons/fa6";

// Menu definitions
const ownerMenu = [
  { name: "Dashboard", path: "/", icon: <MdDashboardCustomize /> },
  { name: "Recharge", path: "/recharge", icon: <FaSackDollar /> },
  { name: "Keys", path: "/keys", icon: <FaKey /> },
  { name: "User Management", path: "/user-management", icon: <FaUsers /> },
  { name: "Show All Ticket", path: "/show-ticket", icon: <MdSupportAgent /> },
  { name: "Demo Req List", path: "/demoform", icon: <FaTablets /> },
];

const subOwnerMenu = [
  { name: "Dashboard", path: "/", icon: <MdDashboardCustomize /> },
  { name: "Recharge", path: "/recharge", icon: <FaSackDollar /> },
  { name: "User Management", path: "/user-management", icon: <FaUsers /> },
  { name: "Show All Ticket", path: "/show-ticket", icon: <IoTicket /> },
  { name: "Assign", path: "/assign", icon: <MdAssignment /> },
  { name: "Playground", path: "/playground", icon: <AiOutlineSetting /> },
];

const vendorMenu = [
  { name: "Dashboard", path: "/", icon: <MdDashboardCustomize /> },
  { name: "Developers", path: "/developer", icon: <FaUserTie /> },
  { name: "Projects", path: "/project", icon: <FaBuilding /> },
  { name: "Campaigns", path: "/campaign", icon: <MdCampaign /> },
  { name: "Assign", path: "/assign", icon: <MdAssignment /> },
  { name: "Knowledge Base", path: "/rag", icon: <RiRobot2Line /> },
  { name: "Prompt", path: "/scripts", icon: <BsTelephoneOutbound /> },
  { name: "Call Logs", path: "/calllogs", icon: <FaPhoneAlt /> },
  {
    name: "Balance Statement",
    path: "/BalanceStatement",
    icon: <FaSackDollar />,
  },
  { name: "User Management", path: "/user-management", icon: <FaUsers /> },
  {
    name: "Number",
    path: "/outbound/createagents/numbers",
    icon: <FaAddressBook />,
  },
];

const participantMenu = [
  { name: "Dashboard", path: "/", icon: <MdDashboardCustomize /> },
  { name: "Agents", path: "/calltype", icon: <RiRobot2Line /> },
  { name: "Agents Assign", path: "/assignpage", icon: <MdManageAccounts /> },
  { name: "My Developers", path: "/developer", icon: <FaUserTie /> },
  { name: "My Projects", path: "/project", icon: <FaBuilding /> },
  { name: "My Campaigns", path: "/campaign", icon: <FaCampground /> },
  { name: "Knowledge Base", path: "/rag", icon: <RiRobot2Line /> },
  { name: "Caller Book", path: "/callbook", icon: <FaAddressBook /> },
  { name: "Call Logs", path: "/calllogs", icon: <FaPhoneAlt /> },
     {
      name: "Meta Campaign",
      icon: <FaMeta />,
      isCollapsible: true,
      subItems: [
        // { name: "Connect", path: "/meta-connect", icon: <FaLink /> },
        { name: "Manager", path: "/camp", icon: <FaChartLine /> },
      ],
    },
];

const menusByDomain = (userRole) => ({
  "health care": [
    { name: "Dashboard", path: "/dashboard", icon: <MdDashboardCustomize /> },
    { name: "Patients", path: "/patients", icon: <FaUsers /> },
    { name: "Appointments", path: "/appointments", icon: <FaPhoneAlt /> },
    { name: "Doctors", path: "/doctors", icon: <FaUserTie /> },
    ...(userRole === "subowner" ||
      userRole === "vendor" ||
      userRole === "participant"
      ? [{ name: "Support", path: "/support", icon: <MdSupportAgent /> }]
      : []),
    { name: "Show Ticket Raised", path: "/show-ticket", icon: <IoTicket /> },
    { name: "Playground", path: "/playground", icon: <AiOutlineSetting /> },
  ],
  "real estate": {
    vendor: [
    { name: "Dashboard", path: "/", icon: <MdDashboardCustomize /> },
    { name: "Developers", path: "/developer", icon: <FaUserTie /> },
    { name: "Projects", path: "/project", icon: <FaBuilding /> },
    { name: "Campaigns", path: "/campaign", icon: <MdCampaign /> },
    { name: "Knowledge Base", path: "/rag", icon: <RiRobot2Line /> },
    { name: "User Management", path: "/user-management", icon: <FaUsers /> },

    { name: "Prompt", path: "/scripts", icon: <BsTelephoneOutbound /> },
    ...(userRole === "subowner" || userRole === "vendor"
      ? [{ name: "Assign", path: "/assign", icon: <MdAssignment /> },
      ]
      : []),

    ...(userRole === "participant"
      ? [{ name: "Agents Assign", path: "/assignpage", icon: <MdManageAccounts /> },
    { name: "Caller Book", path: "/callbook", icon: <FaAddressBook /> }]
      : []),
    { name: "Call Logs", path: "/calllogs", icon: <FaPhoneAlt /> },
    {
      name: "Integrations",
      icon:  <FaLink /> ,
      isCollapsible: true,
      subItems: [
        { name: "Meta", path: "/meta-connect", icon: <FaMeta /> },
                { name: "Google", path: "/meta-connect", icon: <FaGoogle /> },

        // { name: "Manager", path: "/camp", icon: <FaChartLine /> },
        

      ],
    },
  ],
  participant: participantMenu,
},
  recruiter: [
    { name: "Dashboard", path: "/", icon: <MdDashboardCustomize /> },
    { name: "API Key", path: "/recruiter/api-key", icon: <FaKey /> },
    ...(userRole === "vendor"
      ? [
        { name: "Support", path: "/support", icon: <MdSupportAgent /> },
        {
          name: "Show Ticket Raised",
          path: "/show-ticket",
          icon: <IoTicket />,
        },
      ]
      : []),
  ],
  "election party": [
    { name: "Dashboard", path: "/", icon: <MdDashboardCustomize /> },
    { name: "Campaign", path: "/election-campaign", icon: <MdCampaign /> },
    { name: "Prompt", path: "/prompt-template", icon: <BsTelephoneOutbound /> },
    { name: "Assign Credit", path: "/assignCredit", icon: <FaSackDollar /> },
    { name: "Agents", path: "/agents-template", icon: <FaUserTie /> }, // Single Agents item
    { name: "Number", path: "/number", icon: <FaAddressBook /> },
    { name: "Call Logs", path: "/call-logs", icon: <FaPhoneAlt /> },
  ],
});

export default function Sidebar({ isOpen, toggleSidebar, menuContext }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState("Dashboard");
  const [isModalVisible, setModalVisible] = useState(false);
  const [isProfilePopupVisible, setProfilePopupVisible] = useState(false);
  const navRef = useRef(null);
  const profileRef = useRef(null);
  const modalRef = useRef(null);

  const userData = JSON.parse(localStorage.getItem("authData") || "{}");
  const userRole = userData?.user?.role?.toLowerCase() || "vendor";
  const domainType = userData?.user?.domain?.toLowerCase() || "default";
  const userName = userData?.user?.name || "User";

const getCurrentMenu = () => {
  switch (userRole) {
    case "owner":
      return ownerMenu;
    case "subowner":
      return subOwnerMenu;
    case "vendor":
    case "participant":
      // For real estate, get role-specific menu
      if (domainType === "real estate") {
        const realEstateMenus = menusByDomain(userRole)["real estate"];
        return realEstateMenus[userRole] || vendorMenu;  // Fallback to vendorMenu if not found
      }
      // For other domains, use existing logic
      return (
        menusByDomain(userRole)[domainType] ||
        (userRole === "vendor" ? vendorMenu : participantMenu)
      );
    case "salesperson":
      // Handle new salesperson role (maps to participant menu for real estate)
      if (domainType === "real estate") {
        return menusByDomain(userRole)["real estate"].salesperson || participantMenu;
      }
      return participantMenu;  // Fallback
    default:
      return vendorMenu;
  }
};


  const currentMenu = getCurrentMenu();

  useEffect(() => {
    const normalizedPath = location.pathname.replace(/\/$/, "");
    let activeItem = null;
    let activeName = currentMenu[0]?.name || "Dashboard";

    // Check for matching paths
    for (const item of currentMenu) {
      if (item.path && normalizedPath === item.path) {
        activeItem = item;
        activeName = item.name;
        break;
      }
      // Special handling for "Agents" to include multiple paths
      if (item.name === "Agents") {
        const agentPaths = [
          "/agents-template",
          "/election/create-agent",
          "/edit-agent",
        ];
        if (
          agentPaths.includes(normalizedPath) ||
          normalizedPath.startsWith("/edit-agent/")
        ) {
          activeItem = item;
          activeName = "Agents";
          break;
        }
      }
      // Handle other paths with partial matches
      if (
        item.path &&
        normalizedPath.startsWith(item.path) &&
        (!activeItem || item.path.length > activeItem.path.length)
      ) {
        activeItem = item;
        activeName = item.name;
      }
    }
    setActive(activeName);
  }, [location.pathname, currentMenu]);

  useEffect(() => {
    if (!navRef.current) return;

    const links = [
      ...navRef.current.getElementsByClassName(styles.link),
      ...navRef.current.getElementsByClassName(styles.profile),
    ];

    if (isOpen) {
      gsap.timeline().set(links, { x: -50, opacity: 0 }).to(links, {
        x: 0,
        opacity: 1,
        duration: 0.4,
        stagger: 0.1,
        ease: "power2.out",
      });
    } else {
      gsap.timeline().to(links, {
        x: -50,
        opacity: 0,
        duration: 0.4,
        stagger: 0.1,
        ease: "power2.in",
      });
    }
  }, [isOpen]);

  const handleLogoutClick = () => {
    setModalVisible(true);
    setProfilePopupVisible(false);
  };

  const handleConfirmLogout = () => {
    localStorage.clear();
    dispatch(logout());
    navigate("/login");
  };

  const handleProfileClick = () => {
    setProfilePopupVisible(!isProfilePopupVisible);
  };

  return (
    <div
      className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}
    >
      <button
        onClick={toggleSidebar}
        className={`${styles.toggleBtn} ${isOpen ? styles.opentoggleBtn : styles.closedtoggleBtn
          }`}
      >
        {isOpen ? <RiCloseLargeFill /> : <GiHamburgerMenu />}
      </button>

      {isOpen ? (
        <Link to="/" className={styles.logo}>
          <img className={styles.logoimg} src={logo} alt="Logo" />
        </Link>
      ) : (
        <div className={styles.filling}></div>
      )}

      <nav ref={navRef} className={styles.nav}>
        {currentMenu.map((item) =>
          item.isCollapsible ? (
            <div key={item.name} className={styles.collapsibleMenu}>
              <div
                className={`${styles.link} ${active === item.name ? styles.active : ""
                  }`}
              >
                {item.icon}
                {isOpen && (
                  <span className={styles.linkText}>{item.name}</span>
                )}
              </div>
              {isOpen && (
                <div className={styles.subMenu}>
                  {item.subItems.map((sub) => (
                    <Link
                      key={sub.name}
                      to={sub.path}
                      onClick={() => setActive(sub.name)}
                      className={`${active === sub.name ? styles.activeSub : ""} ${styles.subLink
                        }`}
                    >
                      {sub.icon}
                      <span className={styles.subLinkText}>{sub.name}</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <Link
              key={item.name}
              to={item.path}
              onClick={() => setActive(item.name)}
              className={`${active === item.name ? styles.active : ""} ${isOpen ? styles.link : styles.link2
                }`}
              title={!isOpen ? item.name : undefined}
            >
              {item.icon}
              {isOpen && <span className={styles.linkText} title={item.name}>
                {item.name.length > 13
                  ? `${item.name.slice(0, 13)}…`
                  : item.name}
              </span>}
            </Link>
          )
        )}

        <div
          ref={profileRef}
          onClick={handleProfileClick}
          className={`${styles.profile} ${isOpen ? styles.link : styles.link2}`}
          title={!isOpen ? userName : undefined}
        >
          <FaUserCircle />{" "}
          {isOpen && <span className={styles.linkText}>{userName}</span>}
        </div>
      </nav>

      {isProfilePopupVisible && (
        <div
          className={`${styles.profilePopup} ${isOpen ? styles.openPopup : styles.closedPopup
            }`}
        >
          <Link
            to="/view-profile"
            className={styles.popupItem}
            onClick={() => setProfilePopupVisible(false)}
          >
            <FaUser className={styles.popupIcon} /> View Profile
          </Link>
          <Link
            to="/edit-profile"
            className={styles.popupItem}
            onClick={() => setProfilePopupVisible(false)}
          >
            <FaEdit className={styles.popupIcon} /> Edit Profile
          </Link>
          <Link
            to="/support"
            className={styles.popupItem}
            onClick={() => setProfilePopupVisible(false)}
          >
            <MdSupportAgent className={styles.popupIcon} /> Support
          </Link>
          <Link
            to="/show-ticket"
            className={styles.popupItem}
            onClick={() => setProfilePopupVisible(false)}
          >
            <FaTicketAlt className={styles.popupIcon} /> Show Tickets
          </Link>
          <div className={styles.popupItem} onClick={handleLogoutClick}>
            <FiLogOut className={styles.popupIcon} /> Logout
          </div>
        </div>
      )}

      {isModalVisible && (
        <div className={styles.modalOverlay}>
          <div ref={modalRef} className={styles.modalContent}>
            <div className={styles.icon}>
              <ImExit />
            </div>
            <p className={styles.message}>Are you sure you want to logout?</p>
            <div className={styles.actions}>
              <button
                className={styles.cancelButton}
                onClick={() => setModalVisible(false)}
              >
                Cancel
              </button>
              <button
                className={styles.confirmButton}
                onClick={handleConfirmLogout}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}